import axios from "axios";

const api = axios.create({
    baseURL: "https://test2.app.viaro.grena.ge"
});

export default api;